// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* MUI-style slider using native HTML range input */
.mui-style-slider-container {
  position: relative;
  padding: 13px 10px; /* Added horizontal padding */
  width: calc(100% - 20px); /* Adjust width to account for padding */
  margin-top: 8px;
  margin-left: 10px; /* Add left margin to prevent cutoff */
}

/* Hide native slider but keep it functional */
.mui-style-slider-input {
  position: absolute;
  width: 100%;
  height: 40px;
  opacity: 0;
  z-index: 3;
  cursor: pointer;
  margin: 0;
  top: 50%;
  transform: translateY(-50%);
}

/* Track container */
.mui-style-slider-track-container {
  position: relative;
  width: 100%;
  height: 4px;
  pointer-events: none;
}

/* Rail (gray background) */
.mui-style-slider-rail {
  position: absolute;
  width: 100%;
  height: 4px;
  background-color: #E0E0E0;
  border-radius: 2px;
}

/* Active track (turquoise) */
.mui-style-slider-track {
  position: absolute;
  height: 4px;
  background-color: #1976d2;
  border-radius: 2px;
  transition: width 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
}

/* Marks */
.mui-style-slider-mark {
  position: absolute;
  width: 8px;
  height: 8px;
  background-color: #E0E0E0;
  border-radius: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  transition: background-color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
}

.mui-style-slider-mark.active {
  background-color: #1976d2;
}

/* Thumb */
.mui-style-slider-thumb {
  position: absolute;
  width: 20px;
  height: 20px;
  background-color: #1976d2;
  border: 2px solid #1976d2;
  border-radius: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  transition: left 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,
  box-shadow 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  pointer-events: none;
}

/* Hover effect */
.mui-style-slider-input:hover ~ .mui-style-slider-track-container .mui-style-slider-thumb {
  box-shadow: 0 0 0 8px rgba(0, 206, 209, 0.16);
}

/* Active/dragging effect */
.mui-style-slider-thumb.dragging {
  box-shadow: 0 0 0 14px rgba(0, 206, 209, 0.16);
}

/* Tooltip */
.mui-style-slider-tooltip {
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
  margin-bottom: 8px;
  background-color: #1976d2;
  color: white;
  font-size: 12px;
  padding: 4px 8px;
  border-radius: 4px;
  white-space: nowrap;
  pointer-events: none;
}

/* Tooltip arrow */
.mui-style-slider-tooltip::after {
  content: '';
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  width: 0;
  height: 0;
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-top: 4px solid #1976d2;
}

/* Year section from your CSS */
.year-section {
  margin-bottom: 16px;
}

.year-range {
  font-weight: normal;
  color: #666;
}

.mui-style-slider-mark-label {
  position: absolute;
  top: 10px;
  transform: translateX(-50%);
  font-size: 12px;
  color: #aaa;
  white-space: nowrap;
  text-align: center;
  pointer-events: none;
}

.mui-style-slider-value-label {
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
  margin-bottom: 8px;
  background-color: #1976d2;
  padding: 5px 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  color: white;
  font-size: 0.875rem;
  white-space: nowrap;
  opacity: 0;
  transition: opacity 200ms;
  pointer-events: none;
  
}

.mui-style-slider-input:hover ~ .mui-style-slider-track-container .mui-style-slider-value-label,
.mui-style-slider-input:focus ~ .mui-style-slider-track-container .mui-style-slider-value-label,
.mui-style-slider-input:active ~ .mui-style-slider-track-container .mui-style-slider-value-label {
  opacity: 1;
}

/* Month section from your CSS */
.month-section {
  margin-bottom: 16px;
}

.filter-section-title {
  font-size: 16px;
  font-weight: 600;
  color: #1976d2;
  margin-bottom: 3px;
  display: block;
}

.month-range {
  font-weight: normal;
  color: #666;
}

/* For the first label, don't shift left */
.mui-style-slider-mark-label:first-of-type {
  transform: translateX(0);
  text-align: left;
}

/* For the last label, align to the right */
.mui-style-slider-mark-label:last-of-type {
  transform: translateX(-100%);
  text-align: right;
}

/* For the first label, position it to be fully visible */
.mui-style-slider-mark-label.first {
  transform: translateX(0); /* No transform, align to left edge */
  left: 0 !important; /* Override inline style */
  text-align: left;
}

/* For the last label, align to the right */
.mui-style-slider-mark-label.last {
  transform: translateX(-100%);
  text-align: right;
}`, "",{"version":3,"sources":["webpack://./src/components/YearSelectSlider.css"],"names":[],"mappings":"AAAA,mDAAmD;AACnD;EACE,kBAAkB;EAClB,kBAAkB,EAAE,6BAA6B;EACjD,wBAAwB,EAAE,wCAAwC;EAClE,eAAe;EACf,iBAAiB,EAAE,sCAAsC;AAC3D;;AAEA,8CAA8C;AAC9C;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,UAAU;EACV,eAAe;EACf,SAAS;EACT,QAAQ;EACR,2BAA2B;AAC7B;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,oBAAoB;AACtB;;AAEA,2BAA2B;AAC3B;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA,6BAA6B;AAC7B;EACE,kBAAkB;EAClB,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,wDAAwD;AAC1D;;AAEA,UAAU;AACV;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,QAAQ;EACR,gCAAgC;EAChC,mEAAmE;AACrE;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,UAAU;AACV;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,QAAQ;EACR,gCAAgC;EAChC;mDACiD;EACjD,oBAAoB;AACtB;;AAEA,iBAAiB;AACjB;EACE,6CAA6C;AAC/C;;AAEA,2BAA2B;AAC3B;EACE,8CAA8C;AAChD;;AAEA,YAAY;AACZ;EACE,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA,kBAAkB;AAClB;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,QAAQ;EACR,SAAS;EACT,kCAAkC;EAClC,mCAAmC;EACnC,6BAA6B;AAC/B;;AAEA,+BAA+B;AAC/B;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,2BAA2B;EAC3B,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,UAAU;EACV,yBAAyB;EACzB,oBAAoB;;AAEtB;;AAEA;;;EAGE,UAAU;AACZ;;AAEA,gCAAgC;AAChC;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA,0CAA0C;AAC1C;EACE,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA,2CAA2C;AAC3C;EACE,4BAA4B;EAC5B,iBAAiB;AACnB;;AAEA,yDAAyD;AACzD;EACE,wBAAwB,EAAE,qCAAqC;EAC/D,kBAAkB,EAAE,0BAA0B;EAC9C,gBAAgB;AAClB;;AAEA,2CAA2C;AAC3C;EACE,4BAA4B;EAC5B,iBAAiB;AACnB","sourcesContent":["/* MUI-style slider using native HTML range input */\n.mui-style-slider-container {\n  position: relative;\n  padding: 13px 10px; /* Added horizontal padding */\n  width: calc(100% - 20px); /* Adjust width to account for padding */\n  margin-top: 8px;\n  margin-left: 10px; /* Add left margin to prevent cutoff */\n}\n\n/* Hide native slider but keep it functional */\n.mui-style-slider-input {\n  position: absolute;\n  width: 100%;\n  height: 40px;\n  opacity: 0;\n  z-index: 3;\n  cursor: pointer;\n  margin: 0;\n  top: 50%;\n  transform: translateY(-50%);\n}\n\n/* Track container */\n.mui-style-slider-track-container {\n  position: relative;\n  width: 100%;\n  height: 4px;\n  pointer-events: none;\n}\n\n/* Rail (gray background) */\n.mui-style-slider-rail {\n  position: absolute;\n  width: 100%;\n  height: 4px;\n  background-color: #E0E0E0;\n  border-radius: 2px;\n}\n\n/* Active track (turquoise) */\n.mui-style-slider-track {\n  position: absolute;\n  height: 4px;\n  background-color: #1976d2;\n  border-radius: 2px;\n  transition: width 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;\n}\n\n/* Marks */\n.mui-style-slider-mark {\n  position: absolute;\n  width: 8px;\n  height: 8px;\n  background-color: #E0E0E0;\n  border-radius: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  transition: background-color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;\n}\n\n.mui-style-slider-mark.active {\n  background-color: #1976d2;\n}\n\n/* Thumb */\n.mui-style-slider-thumb {\n  position: absolute;\n  width: 20px;\n  height: 20px;\n  background-color: #1976d2;\n  border: 2px solid #1976d2;\n  border-radius: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  transition: left 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,\n  box-shadow 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;\n  pointer-events: none;\n}\n\n/* Hover effect */\n.mui-style-slider-input:hover ~ .mui-style-slider-track-container .mui-style-slider-thumb {\n  box-shadow: 0 0 0 8px rgba(0, 206, 209, 0.16);\n}\n\n/* Active/dragging effect */\n.mui-style-slider-thumb.dragging {\n  box-shadow: 0 0 0 14px rgba(0, 206, 209, 0.16);\n}\n\n/* Tooltip */\n.mui-style-slider-tooltip {\n  position: absolute;\n  bottom: 100%;\n  left: 50%;\n  transform: translateX(-50%);\n  margin-bottom: 8px;\n  background-color: #1976d2;\n  color: white;\n  font-size: 12px;\n  padding: 4px 8px;\n  border-radius: 4px;\n  white-space: nowrap;\n  pointer-events: none;\n}\n\n/* Tooltip arrow */\n.mui-style-slider-tooltip::after {\n  content: '';\n  position: absolute;\n  top: 100%;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 0;\n  height: 0;\n  border-left: 4px solid transparent;\n  border-right: 4px solid transparent;\n  border-top: 4px solid #1976d2;\n}\n\n/* Year section from your CSS */\n.year-section {\n  margin-bottom: 16px;\n}\n\n.year-range {\n  font-weight: normal;\n  color: #666;\n}\n\n.mui-style-slider-mark-label {\n  position: absolute;\n  top: 10px;\n  transform: translateX(-50%);\n  font-size: 12px;\n  color: #aaa;\n  white-space: nowrap;\n  text-align: center;\n  pointer-events: none;\n}\n\n.mui-style-slider-value-label {\n  position: absolute;\n  bottom: 100%;\n  left: 50%;\n  transform: translateX(-50%);\n  margin-bottom: 8px;\n  background-color: #1976d2;\n  padding: 5px 10px;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  color: white;\n  font-size: 0.875rem;\n  white-space: nowrap;\n  opacity: 0;\n  transition: opacity 200ms;\n  pointer-events: none;\n  \n}\n\n.mui-style-slider-input:hover ~ .mui-style-slider-track-container .mui-style-slider-value-label,\n.mui-style-slider-input:focus ~ .mui-style-slider-track-container .mui-style-slider-value-label,\n.mui-style-slider-input:active ~ .mui-style-slider-track-container .mui-style-slider-value-label {\n  opacity: 1;\n}\n\n/* Month section from your CSS */\n.month-section {\n  margin-bottom: 16px;\n}\n\n.filter-section-title {\n  font-size: 16px;\n  font-weight: 600;\n  color: #1976d2;\n  margin-bottom: 3px;\n  display: block;\n}\n\n.month-range {\n  font-weight: normal;\n  color: #666;\n}\n\n/* For the first label, don't shift left */\n.mui-style-slider-mark-label:first-of-type {\n  transform: translateX(0);\n  text-align: left;\n}\n\n/* For the last label, align to the right */\n.mui-style-slider-mark-label:last-of-type {\n  transform: translateX(-100%);\n  text-align: right;\n}\n\n/* For the first label, position it to be fully visible */\n.mui-style-slider-mark-label.first {\n  transform: translateX(0); /* No transform, align to left edge */\n  left: 0 !important; /* Override inline style */\n  text-align: left;\n}\n\n/* For the last label, align to the right */\n.mui-style-slider-mark-label.last {\n  transform: translateX(-100%);\n  text-align: right;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
